import { render, staticRenderFns } from "./ComponentInstance.vue?vue&type=template&id=36471a5d&scoped=true&"
import script from "./ComponentInstance.vue?vue&type=script&lang=js&"
export * from "./ComponentInstance.vue?vue&type=script&lang=js&"
import style0 from "./ComponentInstance.vue?vue&type=style&index=0&id=36471a5d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36471a5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36471a5d')) {
      api.createRecord('36471a5d', component.options)
    } else {
      api.reload('36471a5d', component.options)
    }
    module.hot.accept("./ComponentInstance.vue?vue&type=template&id=36471a5d&scoped=true&", function () {
      api.rerender('36471a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/components/ComponentInstance.vue"
export default component.exports